import React from 'react';
import Card from './Card';
import "../style/project.css"

export default function Project() {
  return (
    <div className="background1" data-aos="fade-up">
      <Card />
    </div>
  );
}
